/* src/app/forms/produtos/shopee/shopee-var-tier/shopee-var-tier.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}
.content {
  display: grid;
  height: 100%;
}
.tier {
  height: 100%;
}
.tier-content {
  height: 100%;
}
.card-data {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-card-title {
  font-size: 130%;
}
.mat-mdc-card-content {
  height: 100%;
  display: flex;
  overflow: auto;
  flex-direction: column;
}
.card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.button {
  display: flex;
}
.button > * {
  margin-right: 6px;
}
.chip-list {
  width: 100%;
}
.data-selection {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.link-label {
  font-weight: 300;
}
.link-label span {
  font-weight: 500;
}
.link-label:hover {
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
}
.foto {
  width: 100%;
  height: 150px;
  margin-bottom: 15px;
  margin-top: 15px;
}
.stepper-section {
  height: 100%;
  overflow: auto;
}
.image-selection-show {
  animation: image-selection-show 150ms cubic-bezier(0, 0, 0.2, 1) forwards;
}
.image-selection-hide {
  animation: image-selection-hide 75ms cubic-bezier(0.4, 0, 1, 1) forwards;
}
@keyframes image-selection-show {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes image-selection-hide {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}
.image-selection {
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid #c7d8e2;
  height: 300px;
  width: 300px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  box-shadow: 10px 10px 35px rgba(0, 0, 0, 0.125), -10px -10px 35px rgba(0, 0, 0, 0.125);
  z-index: 1000;
  height: auto;
  background-color: var(--tem-bg);
  min-height: 200px;
  max-height: 300px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.variation-grid {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  padding-right: 10px;
}
.variation-grid .border {
  border-top: 1px solid var(--tem-border);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
}
.long-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.lines {
  display: grid;
  height: 60px;
  width: 100%;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid var(--tem-border);
  padding-left: 10px;
  padding-right: 10px;
}
.action-image-buttons {
  font-size: 80%;
  bottom: 0;
  float: bottom;
  position: fixed;
  width: 100%;
  padding-bottom: 10px;
}
.image-selection:before {
  content: "";
  position: absolute;
  bottom: 13px;
  right: 298px;
  transform: rotate(270deg);
  border: 10px solid var(--tem-border);
  border-color: transparent transparent #fff transparent;
}
.no-data {
  display: flex;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
.image-gallery-container {
  max-height: calc(100% - 40px);
  max-width: 300px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 6px;
  overflow: auto;
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.image-gallery-container .gallery img {
  width: 100%;
  height: auto;
  border: 2px solid #fff;
  -webkit-transition: -webkit-transform 0.15s ease;
  -moz-transition: -moz-transform 0.15s ease;
  -o-transition: -o-transform 0.15s ease;
  -ms-transition: -ms-transform 0.15s ease;
  transition: transform 0.15s ease;
  position: relative;
  cursor: pointer;
}
.image-gallery-container .gallery {
  position: relative;
}
.check-image {
  position: absolute;
  left: -3px;
  top: -2px;
  height: 20px;
  color: white;
  width: 20px;
}
.item-option-detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
}
.circle-check {
  height: 18px;
  width: 18px;
  background-color: #0481ff;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  top: -2px;
  left: 0;
}
.field-vinculo {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
}
.mat-mdc-form-field {
  width: 100%;
}
.field-options {
  width: 100%;
  margin-top: 25px;
}
/*# sourceMappingURL=shopee-var-tier.component.css.map */
